export enum RescheduleReasonType {
  CANT_SHOW = 'CANT_SHOW',
  PROPERTY_NOT_READY = 'PROPERTY_NOT_READY',
  BOOKING_CONFLICT = 'BOOKING_CONFLICT',
  OTHER = 'OTHER',
}

/** How far beyond the rescheduled slot a CANT_SHOW unavailability extends. */
export enum RescheduleUnavailabilitySpan {
  SLOT = 'SLOT',
  DAY = 'DAY',
  RANGE = 'RANGE',
}

/**
 * The structured "why" behind a reschedule. Captured so scheduling can avoid proposing times the
 * owner already told us won't work; the free-text renter comment stays a message channel and is
 * never treated as the reason.
 */
export interface RescheduleReasonDto {
  type: RescheduleReasonType;
  /** CANT_SHOW only. */
  span: RescheduleUnavailabilitySpan | null;
  /** CANT_SHOW with span RANGE only, YYYY-MM-DD. */
  unavailableFrom: string | null;
  unavailableUntil: string | null;
  /** PROPERTY_NOT_READY only, YYYY-MM-DD. */
  notReadyUntil: string | null;
}
